import axios from "axios";

export const USER_LOG_URL = "/UserLog";

/** Belli Bir Kullanıcı İşlemi (Log) Listesini Elde Eder */
export function getUserLogs(queryParams) {
  return axios.post(`${USER_LOG_URL}/GetUserLogs`, queryParams);
}

/** Belli Bir Kullanıcı İşlemi Sırasında Oluşan Hatayı (Exception) Elde Eder */
export function getException(id) {
  return axios.get(`${USER_LOG_URL}/${id}`);
}